<div
  class="chips-alert {{ incommingChipsAlert.type }}"
  [class.activate]="incommingChipsAlert.activate"
  appAlert
  [show]="incommingChipsAlert.activate"
  [durationSec]="durationSec"
  (showChange)="showChange($event)"
>
  <div class="icon">
    <fa-icon class="center" [icon]="icon"></fa-icon>
  </div>

  <div class="label">{{ incommingChipsAlert.chips | number: '0.0-2' }}</div>
</div>
